const planTabTileRowSize = width => {
  /*
    688 or 896 is how much space is being occupied horizontally
    by the other elements on the screen.
  */
  const freeSpaceForTiles = width < 2048 ? width - 688 : width - 896;
  const tileWidth = 204;

  const columns = Math.floor(freeSpaceForTiles / tileWidth);

  return columns >= 1 ? columns : 1;
};

export default planTabTileRowSize;
